import { Component, Output, EventEmitter, Input} from '@angular/core';
import { Http} from '@angular/http';
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {LeadsService} from "../../../models/leads/leads.service";
import {LeadsModel} from "../../../models/leads/leads.model";
import {LeadsStatusType} from "../../../models/leads/leads.type";

@Component({
    selector: 'lead-set-status',
    templateUrl: 'lead-set-status.template.html'
})
export class LeadSetStatusComponent {

    public leadStatuses: Array<any>;

    public leadReasons: Array<any>;

    private Model: LeadsService;

    public showReason = false;

    @Output() onAfterSave: EventEmitter<LeadsModel> = new EventEmitter<LeadsModel>();

    @Input() leadData;

    is_removed: any = false;

    constructor(private http: Http, private toasterService: ToasterService) {
        this.Model = new LeadsService(this.http);
    }

    ngOnInit(){
        let allStatuses;

        if(this.leadData.visible === LeadsService.LEAD_VISIBLE_SCHEDULE){
            allStatuses = LeadsService.getScheduleStatuses();
        } else {
            allStatuses = LeadsService.getStatuses();
        }

        this.is_removed = this.leadData.visible == LeadsService.LEAD_VISIBLE_FALSE ? true : false;

        this.leadStatuses = allStatuses;

        this.leadReasons = this.Model.getAllReasons();
    }

    public changeLeadStatus(statusElement) {
        this.showReason = false;
        if (statusElement.value === 'select') return;

        if (statusElement.value == LeadsStatusType.NOT_INTERESTED) {
            this.showReason = true;
            return;
        };

        this.saveStatus(statusElement.value, 0);
    }

    public changeLeadReason(reasonElement) {
        if (reasonElement.value === 'select') return;
        this.saveStatus(LeadsStatusType.NOT_INTERESTED, reasonElement.value);
    }

    private saveStatus(statusId, reasonId) {
        let statusModel = {status: +statusId, reason: +reasonId};
        this.Model.setStatus(this.leadData.id, statusModel)
            .map(res => res.json())
            .subscribe(res => {
                let message = res.data.message ? res.data.message : 'Status was changed';
                this.toasterService.pop('success', 'Success', message);
                this.onAfterSave.emit();
            }, (e) => {
                let errorData = JSON.parse(e._body);
                this.toasterService.pop('error', 'Error', errorData.message);
            });
        return true;
    }

}


// WEBPACK FOOTER //
// ./src/app/views/leads/set-status/lead-set-status.component.ts